(() => {
  if(customElements.get('sonia-breloc-customizer')) return;
  class SoniaBrelocCustomizer extends HTMLElement {
    connectedCallback() {
      this.buttons=[...this.querySelectorAll('[data-swb-animal]')];
      this.colors=[...this.querySelectorAll('[data-swb-color]')];
      this.stage=this.querySelector('[data-swb-stage-image]');
      this.disc=this.querySelector('[data-swb-disc]');
      this.title=this.querySelector('[data-swb-stage-name]');
      this.combination=this.querySelector('[data-swb-combination]');
      this.colorLabel=this.querySelector('[data-swb-color-label]');
      this.index=0;
      this.color=(this.dataset.color||'negru').includes('alb')?'white':'black';
      this._onClick=e=>{
        const animal=e.target.closest('[data-swb-animal]');
        if(animal){this.selectAnimal(this.buttons.indexOf(animal));return;}
        const color=e.target.closest('[data-swb-color]');
        if(color){this.changeColor(color.dataset.swbColor,true);return;}
        if(e.target.closest('[data-swb-prev]'))this.selectAnimal((this.index+this.buttons.length-1)%this.buttons.length);
        if(e.target.closest('[data-swb-next]'))this.selectAnimal((this.index+1)%this.buttons.length);
      };
      this._onChange=e=>{
        if(!e.target.closest('variant-selects')) return;
        const v=e.target.value||'';
        if(v.toLowerCase().includes('alb'))this.changeColor('white',false);
        else if(v.toLowerCase().includes('negru'))this.changeColor('black',false);
      };
      this.addEventListener('click',this._onClick);
      document.addEventListener('change',this._onChange);
      this.selectAnimal(0);
      this.changeColor(this.color,false);
    }
    disconnectedCallback(){this.removeEventListener('click',this._onClick);document.removeEventListener('change',this._onChange);}
    selectAnimal(i){
      if(i<0||i>=this.buttons.length)return;
      this.index=i;
      const b=this.buttons[i];
      this.buttons.forEach((v,j)=>v.setAttribute('aria-pressed',String(i===j)));
      this.stage.src=b.dataset.img;
      this.stage.alt='Previzualizare breloc '+b.dataset.name+' cu tag '+(this.color==='white'?'alb':'negru');
      this.title.textContent=b.dataset.short;
      this.style.setProperty('--swb-top',b.dataset.tagTop);
      this.style.setProperty('--swb-size',b.dataset.tagSize);
      this.querySelector('[data-swb-track]')?.scrollTo({left:b.offsetLeft-this.buttons[0].offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
      this.updateCombination();
    }
    changeColor(color,syncPicker){
      if(color!=='black'&&color!=='white')return;
      this.color=color;
      this.disc.classList.toggle('swb__disc--black',color==='black');
      this.disc.classList.toggle('swb__disc--white',color==='white');
      this.colors.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.swbColor===color)));
      this.colorLabel.textContent=color==='white'?'Alb':'Negru';
      this.updateCombination();
      if(syncPicker){
        const picker=document.querySelector('variant-selects[data-product-id="'+this.dataset.productId+'"]');
        const select=[...(picker?.querySelectorAll('select[name^="options["]')||[])].find(s=>[...s.options].some(o=>/^(Alb|Negru)$/i.test(o.value.trim())));
        if(select){
          const option=[...select.options].find(o=>o.value.trim().toLowerCase()===(color==='white'?'alb':'negru'));
          if(option&&select.value!==option.value){select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));}
        }
      }
    }
    updateCombination(){
      const b=this.buttons[this.index];
      if(!b)return;
      const color=this.color==='white'?'alb':'negru';
      this.combination.textContent=b.dataset.short+' + tag '+color;
      this.stage.alt='Previzualizare breloc '+b.dataset.name+' cu tag '+color;
    }
  }
  customElements.define('sonia-breloc-customizer',SoniaBrelocCustomizer);
})();